import {combineReducers} from 'redux';
import storeSlice from './storeSlice';
import dataSlice from './dataSlice';

export default {
    storeSlice: storeSlice,
    dataSlice: dataSlice,
};
